import { Box, Typography } from '@mui/material'
import { spacing } from 'c1ui'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

/**
 * Warning message that appears if we can't reach the CDN.
 * Uses an inline script that runs during initial HTML parse (before React hydration).
 * If React hydrates successfully, the parent component unmounts before this shows.
 */
export const CdnWarning: FC = () => (
    <>
        <script
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: `
                    (function() {
                        var cdnUrl = window.__NEXT_DATA__ && window.__NEXT_DATA__.assetPrefix;
                        if (!cdnUrl) return; // assetPrefix is only set in prod, skip in dev
                        
                        var timeout = setTimeout(function() {
                            var w = document.getElementById('cdn-warning');
                            if (w) w.style.opacity = '1';
                        }, 5000);
                        
                        fetch(cdnUrl + '/', { method: 'HEAD', cache: 'no-store' })
                            .then(function() { clearTimeout(timeout); })
                            .catch(function() {
                                var w = document.getElementById('cdn-warning');
                                if (w) w.style.opacity = '1';
                            });
                    })();
                `,
            }}
        />
        <Box
            id="cdn-warning"
            sx={{
                mt: 3,
                maxWidth: 400,
                textAlign: 'center',
                px: 2,
                opacity: 0,
                transition: 'opacity 0.5s ease-in',
            }}
        >
            <Typography color="text.secondary" sx={{ fontFamily: 'Inter, sans-serif' }}>
                <FormattedMessage
                    id="component_auth_cdn_warning"
                    defaultMessage="Having trouble connecting. Please verify that {cdn} is not blocked by your firewall or proxy."
                    values={{
                        cdn: (
                            <Typography
                                variant="monospace"
                                component="code"
                                sx={{
                                    backgroundColor: 'grey.100',
                                    py: `calc(${spacing.xs} / 2)`,
                                    px: `calc(${spacing.s} / 2)`,
                                    borderRadius: C1BorderRadius.small,
                                    fontFamily: 'monospace',
                                }}
                            >
                                *.ctr1.net
                            </Typography>
                        ),
                    }}
                />
            </Typography>
        </Box>
    </>
)
